import * as React from 'react';
import '../scss/index.scss';
import Dialog from '@/pages/components/dialog';
import DatePicker from '@/pages/components/datePicker';
import request from '@/server/request';
import config from '@/server/config';
import store from '@/redux';
import * as ConfirmStore from '@/redux/ui/confirm';

export default class OrderMangement extends React.Component<{}, any>  {
	private loadTimer: any;
	private page: number = 1; // 页码
	private isLoading: boolean = true; // 是否加载中
	constructor(props: any) {
		super(props);
		this.state = {
			showMask: false, // 显示遮罩
			showRemarks: false, // 显示留言
			showbuyerInfo: false, // 显示买家
			showInclude: false, // 显示筛选
			status: '', // 状态码
			statusName: '全部', // 状态名
			list: [], // 列表数据
			loadOver: false, // 加载完成
			remarksInfo: '', // 备注信息
			buyerInfo: {}, // 买家信息
			startTime: '', // 开始时间
			endTime: '', // 结束事件
			modelOrderSn: '', // 订单编号
			modelUserName: '', // 用户名
			modelBrand: '', // 品牌
		}
	} 

	public componentDidMount() { 
        this.getList();
        window.addEventListener('scroll', this.scrollAction.bind(this));
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
        if (this.loadTimer) { 
            clearTimeout(this.loadTimer);
        }
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }

	public render() {
		const state = this.state;
		return (
			<div className="gray-bg page-orderMangement">
				{
					state.showMask ? <div className="mask" onClick={() => this.filterStatus(false)}></div> : ''
				}
				<Dialog visiblity={state.showRemarks}>
					<div className="fill-box">
						<p className="fill-title">备注</p>
						<p className="types-prompt">
							{state.remarksInfo}
						</p>
						<div className="fill-btn">
							<button className="btn font-blod" onClick={() => this.changeState('showRemarks', false)}>确定</button>
						</div>
					</div>
				</Dialog>

				<Dialog visiblity={state.showbuyerInfo}>
					<div className="fill-box">
						<p className="fill-title">联系买家</p>
						<div className="buyer-info">
							<p className="text">买家信息：</p>
							<p className="text">{state.buyerInfo.buyerCompanyName} {state.buyerInfo.buyerMemberName}</p>
							<p className="text margin">配送信息：</p>
							<p className="text">{state.buyerInfo.user} <a href={`tel:${state.buyerInfo.mobile}`}>{state.buyerInfo.mobile}</a></p>
							<p className="text">{state.buyerInfo.province} {state.buyerInfo.city} {state.buyerInfo.district} {state.buyerInfo.address}</p>
						</div>
						<div className="fill-btn">
							<button className="btn" onClick={() => this.changeState('showbuyerInfo', false)}>关闭</button>
						</div>
					</div>
				</Dialog>

				{
					state.showInclude ?
					<div className="include-box">
						<div className="default-form">
							<div className="form-input-warrper">
								<label className="label"><span className="red">*</span>开始时间</label>
								<button
									className="input-select text-right" 
									data-value={state.startTime}
									onClick={() => this.selectDate('startTime')}
									>
									{ state.startTime || '请选择开始时间' }
								</button>
							</div>
							<div className="form-input-warrper">
								<label className="label"><span className="red">*</span>结束时间</label>
								<button
									className="input-select text-right"
									data-value={state.endTime}
									onClick={() => this.selectDate('endTime')}
								>
									{ state.endTime || '请选择结束时间' }
								</button>
							</div>
						</div>
						<div className="default-form mt-20">
							<div className="form-input-warrper">
								<input
									type="text" 
									placeholder="请输入订单编号" 
									value={state.modelOrderSn}
									onChange={ (e:any) => this.changeState('modelOrderSn', e.target.value) }
									/>
							</div>
							<div className="form-input-warrper">
								<input
									type="text" 
									placeholder="请输入用户名、用户公司名称" 
									value={state.modelUserName} 
									onChange={ (e:any) => this.changeState('modelUserName', e.target.value) }
									/>
							</div>
							<div className="form-input-warrper">
								<input
									type="text" 
									placeholder="请输入品牌、牌号" 
									value={state.modelBrand} 
									onChange={ (e:any) => this.changeState('modelBrand', e.target.value) }
									/>
							</div>
						</div>
							<div className="default-btn-warrper order-btns">
							<button className="default-btn disabled-btn" onClick={() => this.changeState('showInclude', false)}>取消</button>
								<button className="default-btn disabled-btn" onClick={() => this.filterReset()}>重置</button>
							<button className="default-btn" onClick={() => this.filterConfirm()}>确定</button>
						</div>
					</div> : ''
				}

				<div className="order-top clearfix">
					<div className="left">
						<span className="choose-btn" onClick={() => this.filterStatus(true)}>{state.statusName}</span>
						{
							state.showMask ?
							<div className="choose-select">
								<span className="trangle"></span>
								<ul className="select-list">
										<li className="item" onClick={() => this.selectStatus('', '全部')}>全部</li>
									<li className="item" onClick={() => this.selectStatus(-10, '已关闭')}>已关闭</li>
									<li className="item" onClick={() => this.selectStatus(10, '待付款')}>待付款</li>
									<li className="item" onClick={() => this.selectStatus(15, '待确认付款')}>待确认付款</li>
									<li className="item" onClick={() => this.selectStatus(20, '待发货')}>待发货</li>
									<li className="item" onClick={() => this.selectStatus(30, '已发货')}>已发货</li>
									<li className="item" onClick={() => this.selectStatus(40, '已完成')}>已完成</li>
								</ul>
							</div> : ''
						}
						
					</div>
					<span className="right" onClick={() => this.changeState('showInclude', true)}>筛选<i className="icon"/></span>
				</div>
				
				{
					state.list.map((v: any, k: number) => { 
						return (
							<div className="order-card" key={v.id}>
								<div className="content">
									<p className="number">
										<span className="num">{v.orderSn}</span>
										<span className={(v.status === 10 || v.status === 15) ? 'status' : 'status-normal'}>{this.renderStatus(v.status)}</span>
									</p>
									<p className="time">
										{v.createTime}
									</p>
									<p className="info">
										<span className="company">{v.buyerCompanyName}</span>
										<span className="concat" onClick={() => this.changeState('showbuyerInfo', true, v)}><i className="icon"/>联系买家</span>
									</p>
									<div className="product-list">
										{
											v.products.map((pv: any, pk: number) => { 
												return (
													<div className={`item ${(pk < 3 || v.showAll) ? 'active' : ''}`} key={pv.goodsId} onClick={() => this.navigateToGoodsDetail(pv.skuUrl)}>
														<img src={pv.imgUrl} alt=""  className="img"/>
														<div className="product-info">
															<p className="info-name line-clamp-2">{pv.goodsName}</p>
															<p className="info-company line-clamp-1">{pv.factory}</p>
														</div>
														<div className="price-info">
															<p className="price line-clamp-1">￥{pv.price}</p>
															<p className="num">x{pv.qty}</p>
															<p className="freight line-clamp-1">运费: ￥{pv.freight}</p>
														</div>
													</div>
												)
											})
										}
									</div>
									{
										v.products && v.products.length > 3 && !v.showAll ?
										<p className="text-center">
												<span className="spread-btn" onClick={() => this.showAllProducts(v, k)}>展开剩余{v.products.length - 3}件商品<i className="icon"/></span>
										</p> : null
									}									
									<p className="total">
										<span className="total-num">共{v.products.length}件商品，实付款(含运费￥{v.totalFreight})：</span>
										<span className="total-price">￥{v.totalAmount}</span>
									</p>
								</div>
								{
									(v.buyerRemark || v.status === 10 || v.status === -10 || v.status === 15 || v.status === 20) ?
										<div className="order-bottom">
											{
												v.buyerRemark ? <button className="btn btn1" onClick={() => this.changeState('showRemarks', true, v.buyerRemark)}>备注</button> : null
											}
											{
												v.status === 10 ? <button className="btn btn2" onClick={() => this.orderCancel(v.id, k)}>取消订单</button> : null
											}
											{
												v.status === -10 ? <button className="btn btn2 red" onClick={() => this.orderDelete(v.id, k)}>删除</button> : null
											}
											{
												v.status === 15 ? <button className="btn btn2 red" onClick={() => this.orderPay(v.id, k)}>确认付款</button> : null
											}
											{
												v.status === 20 ? <button className="btn btn2" onClick={() => this.deliverGoods(v.id, k)}>发货</button> : null
											}
										</div> : null
								}
							</div>
						)
					})
				}
				
				<p className="loading-tips">{state.loadOver ? '没有更多数据' : '数据加载中...'}</p>
			</div>
		)
	}

	// 获取页面数据
	private async getList() { 
		const r = await request({
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			},
			url: `${config.ORDERAPI}wiseshop/wap/seller/order/list?pageSize=10&pageNum=${this.page}&status=${this.state.status}&name=${this.state.modelUserName}&orderSn=${this.state.modelOrderSn}&goodsInfo=${this.state.modelBrand}&createTimeStart=${this.state.startTime}&createTimeEnd=${this.state.endTime}`
		});
		
		if (r.code === 1) { 
			this.isLoading = false;
			this.setState({
				list: this.state.list.concat(r.obj.list),
				loadOver: r.obj.pageNum >= r.obj.pages
			});
		}
	}

	// 滚动加载更多
    private scrollAction() {
        if (this.isLoading || this.state.loadOver) { 
            return;
        }
        
		if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {
			
            if (this.loadTimer) { 
                clearTimeout(this.loadTimer);
			}
			
            this.loadTimer = setTimeout(() => {
                this.loadMore();
			}, 500);
			
        }
    }

    // 加载更多文章内容
	private loadMore() { 
		this.page++;
		this.isLoading = true;
		this.getList();
    }

	/**
	 * 更新state
	 * @param k {string} state对应key
	 * @param v {string} key对应的value
	 * @param arg {any} 附带参数
	 */
	private changeState(k: string, v: any, arg?: any) {
		let remarksInfo = '';
		let buyerInfo = {};
		if (k === 'showRemarks') {
			remarksInfo = arg || '';
		} else if (k === 'showbuyerInfo') { 
			buyerInfo = arg ? {
				buyerMemberName: arg.buyerMemberName,
				buyerCompanyName: arg.buyerCompanyName,
				user: arg.address ? arg.address.linkman : '',
				mobile: arg.address ? arg.address.phone : '',
				province: arg.address ? arg.address.provinceName : '',
				city: arg.address ? arg.address.cityName : '',
				district: arg.address ? arg.address.districtName : '',
				address: arg.address ? arg.address.address : ''
			} : {}
		}
		this.setState({
			[k]: v,
			remarksInfo,
			buyerInfo
		})
	}
	
	/**
	 * 选择事件
	 * @params name: state中需要更新字段的名字
	 */
    private selectDate(name?: any) {
    	const that = this;

    	DatePicker.open({
    	 	onCancelFn: (data: any) => {
    	 		
				that.setState({
					[name]: data.defaultDate
				});

    	 	}
    	})
	}

	// 筛选重置
	private filterReset() { 

		this.setState({
			startTime: '',
			endTime: '',
			modelOrderSn: '',
			modelUserName: '',
			modelBrand: ''
		}, () => { 
			this.resetAction();
		});

	}
	
	// 筛选确认
	private filterConfirm() { 
		
		this.resetAction();
		this.changeState('showInclude', false);

	}

	/**
	 * 渲染状态
	 * @param status 状态码
	 */
	private renderStatus(status: number): string { 

		switch (status) { 
			case -20:
				return '已删除';
			case -10:
				return '已关闭';
			case -1:
				return '已取消';
			case 10:
				return '待付款';
			case 15:
				return '待确认付款';
			case 20:
				return '已付款';
			case 30:
				return '已发货';
			case 40:
				return '已完成';
			default:
				return '';
		}

	}
	/**
	 * 跳转到详情
	 * @param url {string|undefined} 商品链接
	 */
	private navigateToGoodsDetail(url: string | undefined) { 
		
		(window as any).location.href = url;

	}

	/**
	 * 显示所有商品
	 * @param item {any} 订单数据 
	 * @param index {number} 订单索引
	 */
	private showAllProducts(item: any, index: number) { 

		item.showAll = !item.showAll;
		const temp = this.state.list;
		temp[index] = item;
		this.setState({
			list: temp
		});

	}

	/**
	 * 状态筛选
	 * @param visible {boolean} 显示隐藏
	 */
	private filterStatus(visible: boolean) { 

		const style = visible ? 'height: 100%; overflow: hidden;' : '';
		(document as any).documentElement.style = style;
		(document as any).body.style = style;
		this.setState({
			showMask: visible
		});

	}

	/**
	 * 选择状态
	 * @param status {any} 状态码
	 * @param statusName {string} 状态名
	 */
	private selectStatus(status: any, statusName: string) { 

		this.setState({
			status,
			statusName
		}, () => { 
				this.resetAction();
		});
		this.filterStatus(false);

	}

	// 重置数据
	private resetAction() {

		this.page = 1;
		this.isLoading = true;
		this.setState({
			list: [],
			loadOver: false
		}, () => { 
				this.getList();	
		});

	}

	/**
	 * 取消订单
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private orderCancel(id: number, k: number) { 

		store.dispatch({
			type: ConfirmStore.types.CONFIRM_SHOW,
			data: {
				text: '是否取消订单',
				onConfirm: () => { 
					this.cancelAction(id, k);
				}
			}
		});

	}

	/**
	 * 取消订单处理
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private async cancelAction(id: number, k: number) { 

		const r = await request({
			url: `${config.ORDERAPI}wiseshop/wap/seller/order/cancel`,
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			},
			data: {
				id
			}
		});
		
		if (r.code === 1) { 
			const temp = this.state.list;
			temp[k].status = -10;
			this.setState({
				list: temp
			});
		}

	}

	/**
	 * 删除订单
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private orderDelete(id: number, k: number) { 

		store.dispatch({
			type: ConfirmStore.types.CONFIRM_SHOW,
			data: {
				text: '是否删除订单',
				onConfirm: () => { 
					this.deleteAction(id, k);
				}
			}
		});

	}

	/**
	 * 删除订单处理
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private async deleteAction(id: number, k: number) { 

		const r = await request({
			url: `${config.ORDERAPI}wiseshop/wap/seller/order/delete`,
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			},
			data: {
				id
			}
		});

		if (r.code === 1) { 
			const temp = this.state.list;
			temp.splice(k, 1);
			this.setState({
				list: temp
			});
		}

	}

	/**
	 * 确认付款
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private orderPay(id: number, k: number) { 

		store.dispatch({
			type: ConfirmStore.types.CONFIRM_SHOW,
			data: {
				text: '是否确认付款',
				onConfirm: () => { 
					this.payAction(id, k);
				}
			}
		});

	}

	/**
	 * 确认付款处理
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private async payAction(id: number, k: number) { 

		const r = await request({
			url: `${config.ORDERAPI}wiseshop/wap/seller/order/confirm/pay`,
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			},
			data: {
				id
			}
		});

		if (r.code === 1) { 
			const temp = this.state.list;
			temp[k].status = 20;
			this.setState({
				list: temp
			});
		}

	}

	/**
	 * 发货
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private deliverGoods(id: number, k: number) { 

		store.dispatch({
			type: ConfirmStore.types.CONFIRM_SHOW,
			data: {
				text: '是否确认发货',
				onConfirm: () => { 
					this.deliverGoodsAction(id, k);
				}
			}
		});

	}

	/**
	 * 发货处理
	 * @param id {number} 订单id
	 * @param k {number} 订单索引
	 */
	private async deliverGoodsAction(id: number, k: number) { 

		const r = await request({
			url: `${config.ORDERAPI}wiseshop/wap/seller/order/delivery`,
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			},
			data: {
				id
			}
		});

		if (r.code === 1) { 
			const temp = this.state.list;
			temp[k].status = 30;
			this.setState({
				list: temp
			});
		}

	}

	
}